import React from 'react'
import './GlobalDelivery.css'

const GlobalDelivery = () => {
  return (
    <div className="global-delivery-container">
      <div className="content-wrapper">
        <div className="image-column">
          <div className="image-wrapper">
            {' '}
            {/* New wrapper div */}
            <img src="/imgs/deepmind2.png" alt="AI Best Practices" className="delivery-image" />
          </div>
        </div>
        <div className="text-column">
          <h1 className="main-heading">We Deliver Global AI Best Practices</h1>
          <p className="description-text">
            Our extensive risk analysis procedures and standards ensures your organization can
            release AI to the public with confidence that public harm is sufficiently unlikely to
            happen.
          </p>
          <div className="divider"></div>
        </div>
      </div>
    </div>
  )
}

export default GlobalDelivery
